import { concatMap, of, OperatorFunction } from 'rxjs';

/**
 * Works like tap but only runs side effect a set amount of times.
 * Runs 1 time if no tapIndex is set.
 * @param {function} tapFunction side effect to run.
 * @param {number} tapIndex index to stop at, defaults to 0.
 * @returns {function}
 */
export function tapOnce<T>(tapFunction: (t: T) => void, tapIndex = 0): OperatorFunction<T, T> {
  return source$ =>
    source$.pipe(
      concatMap((value, index) => {
        if (index === tapIndex) {
          tapFunction(value);
        }
        return of(value);
      })
    );
}
